import { Injectable } from '@angular/core';
import { ApiConfig } from '../config/apiConfig';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfService } from 'src/conf.service';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PacService {
  private rootUrl: string;
  private pacAPIUrl;

  constructor(private http: HttpClient) {
    this.rootUrl = ConfService.conf.environment.apiRootUrl;
    this.pacAPIUrl = ApiConfig.PacApiConfig;
   }

  	
	getSRDashboard(pacObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.pacAPIUrl.getSRDashboard}`, pacObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getCommon_Questions(pacObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.pacAPIUrl.getCommon_Questions}`, pacObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getCommonQuestionValues(pacObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.pacAPIUrl.getCommonQuestionValues}`, pacObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getPACAll(pacObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.pacAPIUrl.getPACAll}`, pacObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getPAC(pacObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.pacAPIUrl.getPAC}`, pacObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getPACDashboard(pacObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.pacAPIUrl.getPACDashboard}`, pacObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getDelayReasons(pacObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.pacAPIUrl.getDelayReasons}`, pacObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	createPACResponse(pacObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.pacAPIUrl.createPACResponse}`, pacObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	createPACGroup(pacObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.pacAPIUrl.createPACGroup}`, pacObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

  createPACResponseasync(pacObj: any): Promise<any> {
		return this.http.post(`${this.rootUrl}${this.pacAPIUrl.createPACResponse}`, pacObj).toPromise();
      
  }
  
	async createPACGroupasync(pacObj: any): Promise<any> {
		return this.http.post(`${this.rootUrl}${this.pacAPIUrl.createPACGroup}`, pacObj).toPromise();
      // .pipe(
      //   tap(() => {
      //     //
      //   })
      // );
	}
  async getDelayReasonsasync(pacObj: any):Promise<any> {
		return this.http.post(`${this.rootUrl}${this.pacAPIUrl.getDelayReasons}`, pacObj).toPromise();
      // .pipe(
      //   tap(() => {
      //     //
      //   })
      // );
	}


}
